var getTarget = function getTarget(menuItem) {
  return menuItem.target ? {
    target: menuItem.target
  } : {};
};

var getTargetSimple = function getTargetSimple(target) {
  return target ? {
    target: target
  } : {};
};

var clickDropdownItem = function clickDropdownItem(e, menuRef) {
  var _a;

  if (e.key === 'Enter') {
    var items = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.children;
    var array = Array.from(items);
    var item = array.filter(function (node) {
      return node.classList.contains('highlighted');
    });
    var link = item[0].getElementsByTagName('A');
    if (link[0]) link[0].click();
  }
};

var checkIfChildIsA = function checkIfChildIsA(linkWrapper, navItem) {
  return linkWrapper && linkWrapper({
    item: navItem,
    props: {}
  }).props && linkWrapper({
    item: navItem,
    props: {}
  }).props.children && linkWrapper({
    item: navItem,
    props: {}
  }).props.children.type && linkWrapper({
    item: navItem,
    props: {}
  }).props.children.type === 'a';
};

export { checkIfChildIsA, clickDropdownItem, getTarget, getTargetSimple };